// extracted by mini-css-extract-plugin
export var img = "M_B";
export var txt = "M_s";
export var video = "M_5";